import React, { useEffect, useState } from 'react';

const YT_VIDEO_ID = 'VzQov0gs_2c';
const STORAGE_KEY = 'firstMonthModalShown';

const FirstMonthModal = () => {
  const [visible, setVisible] = useState(false);
  const [playBackground, setPlayBackground] = useState(false);

  useEffect(() => {
    try {
      const hasShown = localStorage.getItem(STORAGE_KEY);
      if (!hasShown) {
        setVisible(true);
        // Mark as shown so it only appears on first visit
        localStorage.setItem(STORAGE_KEY, 'true');
      }
    } catch {
      // If localStorage fails, still show the modal
      setVisible(true);
    }
  }, []);

  const handleShowRanks = () => {
    setPlayBackground(true);
    setVisible(false);
  };

  const handleClose = () => {
    setVisible(false);
  };

  // Build embed URL for autoplay with sound after user interaction
  const embedSrc = `https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&mute=0&controls=0&rel=0&modestbranding=1&playsinline=1`;

  return (
    <>
      {/* Hidden background player (kept mounted after modal closes) */}
      {playBackground && (
        <iframe
          title='Tech Hub 1st Month Background Video'
          src={embedSrc}
          allow='autoplay; encrypted-media'
          style={{
            position: 'fixed',
            bottom: 0,
            right: 0,
            width: '1px',
            height: '1px',
            opacity: 0,
            pointerEvents: 'none',
            zIndex: -1,
          }}
        />
      )}

      {/* Modal Overlay */}
      {visible && (
        <div
          role='dialog'
          aria-modal='true'
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000,
          }}
          onClick={handleClose}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)',
              border: '1px solid #333',
              borderRadius: 16,
              padding: '24px 24px 16px',
              width: 'min(560px, 92vw)',
              color: '#fff',
              boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
              textAlign: 'center',
              position: 'relative',
            }}
          >
            <button
              aria-label='Close'
              onClick={handleClose}
              style={{
                position: 'absolute',
                top: 10,
                right: 12,
                background: 'transparent',
                color: '#999',
                border: 0,
                fontSize: 22,
                cursor: 'pointer',
              }}
            >
              ×
            </button>

            <h2 style={{ marginTop: 6, marginBottom: 8 }}>
              🎉 Congratulations
            </h2>
            <p style={{ margin: 0, color: '#ccc' }}>
              You’ve successfully completed the first month of this bootcamp.
              Keep the momentum going!
            </p>

            <div style={{ marginTop: 20 }}>
              <button
                onClick={handleShowRanks}
                style={{
                  background: '#61DAFB',
                  color: '#000',
                  border: 'none',
                  fontWeight: 700,
                  letterSpacing: 0.3,
                  padding: '12px 18px',
                  borderRadius: 10,
                  cursor: 'pointer',
                  boxShadow: '0 10px 24px rgba(97,218,251,0.3)',
                }}
              >
                Show 1st Month Ranks
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FirstMonthModal;
